import {
  call,
  put,
  takeEvery,
} from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import {
  showErrorNotification,
} from 'store/shared/actions';
import { CREATE_PROJECT_SUCCESS, EDIT_PROJECT_SUCCESS, DELETE_PROJECT_SUCCESS } from 'store/project/constants';
import sortByName from 'library/helpers/sort-by-name';
import * as constants from './constants';
import * as actions from './actions';

function* getProjects(action) {
  try {
    const params = {
      query: {
        limit: 10,
        name: action?.payload?.name ?? '',
      },
    };

    const { data } = yield call(request, API.BROWSE_PROJECTS_BY_NAME, 'GET', params);

    yield put(actions.getProjectsSuccess(data.sort(sortByName)));
  } catch (e) {
    yield put(actions.getProjectsError(e));
    yield put(showErrorNotification({ message: 'Failed to fetch data, please try later.' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getProjectsWatcher() {
  // CREATE_PROJECT_SUCCESS, EDIT_PROJECT_SUCCESS and DELETE_PROJECT_SUCCESS actions to be from removed above
  // when search by set name parts is ready on API
  yield takeEvery([constants.GET_PROJECTS, CREATE_PROJECT_SUCCESS, EDIT_PROJECT_SUCCESS, DELETE_PROJECT_SUCCESS], getProjects);
}
